"use strict";
/*
 * Created on 17. 8. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var AbstractReleasePart_1 = require("./AbstractReleasePart");
/**
 * Part of price release that can be approved or exported as the whole.
 * There is workflow bound to this composite entity.
 *
 * @author Radek Beran
 * @author SMi
 */


var ReleasePart =
/*#__PURE__*/
function (_AbstractReleasePart_) {
  _inherits(ReleasePart, _AbstractReleasePart_);

  /**
   * Creates new release part. Current workflow state can be determined from referenced workflow case.
   * @param releaseId id of release
   * @param productCategoryId id of product category for which separate approval and submission of prices is done
   * @param workflowCaseId id of workflow instance if workflow is already initiated
   * @param calcWorkflowCaseId ID of last workflow which re-calculated optimal prices within this release part
   * (filled only in case of category recalculation)
   * @param cmDeadlineMissed true if CM approval was in delay - CM deadline was missed, higher role must approve the prices instead
   * @param approved date of release part (category) approval if category of release part was finally approved
   * @param firstApproval The same as before. However, only the first date of approval is saved in case of subsequent release re-opening.
   * @param approvedByUserId user id (who has been approved categoryPart)
   * @param approvedByUserName name of user who approved category part
   * @param validationResult validation messages (alerts) on release part level
   * @param calcProgressMonitorId ID of a monitor associated with this part and monitoring the part's prices (re)calculation.
   *          All parts can have linked the same monitor. It is e.g. the case of initial opening of an entire release
   *          when progress in any part adds to the progress of the entire operation.
   *          Null value means, that there is no currently running progress (e.g. operation not started yet
   *          or has been already finished).
   * @param readonly true if all items in this category cannot be edited, repriced and were not exported
   * @param manualPrices Flag indicating whether manual prices entered by user should be kept during prices optimization of this release
   *        release part. If the value is 'true', all items with manual price set should have the input range for YDG constructed as
   *        min=max=manual price value and the optimal price should never update the manual price value (despite the fact that YDG
   *        returned price which differed from manual price value). If the value is false, the input range for optimization should
   *        be constructed according to rules defined by matrix table and the manual price value of an item should be updated using
   *        optimized value.
   *        Not nullable. Default value is set to true even for historical releases. Releases in opened state should be fully calculated
   *        in a new way described by PROFACT-75.
   */
  function ReleasePart(releaseId, productCategoryId, workflowCaseId, calcWorkflowCaseId, cmDeadlineMissed, approved, firstApproval, approvedByUserId, approvedByUserName, validationResult, calcProgressMonitorId, readonly, manualPrices) {
    var _this;

    _classCallCheck(this, ReleasePart);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleasePart).call(this, releaseId, productCategoryId, approved, firstApproval, approvedByUserId, approvedByUserName, cmDeadlineMissed, workflowCaseId, calcWorkflowCaseId, calcProgressMonitorId, validationResult, readonly));
    _this.releaseId = releaseId;
    _this.productCategoryId = productCategoryId;
    _this.workflowCaseId = workflowCaseId;
    _this.calcWorkflowCaseId = calcWorkflowCaseId;
    _this.cmDeadlineMissed = cmDeadlineMissed;
    _this.approved = approved;
    _this.firstApproval = firstApproval;
    _this.approvedByUserId = approvedByUserId;
    _this.approvedByUserName = approvedByUserName;
    _this.validationResult = validationResult;
    _this.calcProgressMonitorId = calcProgressMonitorId;
    _this.readonly = readonly;
    _this.manualPrices = manualPrices;
    return _this;
  }
  /**
   * Returns true if given release part is regular release part.
   * Use this method rarely, only in meaningful cases.
   */


  _createClass(ReleasePart, [{
    key: "withMessage",
    value: function withMessage(message) {
      return this.copy('validationResult', this.validationResult.addObject(message));
    }
  }], [{
    key: "isRegularReleasePart",
    value: function isRegularReleasePart(releasePart) {
      return releasePart instanceof ReleasePart;
    }
  }]);

  return ReleasePart;
}(AbstractReleasePart_1.AbstractReleasePart);

exports.ReleasePart = ReleasePart;

ReleasePart.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ReleasePart.name);
  return {
    releaseId: builder.str('releaseId'),
    productCategoryId: builder.str('productCategoryId'),
    approved: builder.opt(builder.date('approved', DateParser_1.DateParser.ISO_PATTERN)),
    firstApproval: builder.opt(builder.date('firstApproval', DateParser_1.DateParser.ISO_PATTERN)),
    approvedByUserId: builder.opt(builder.str('approvedByUserId')),
    approvedByUserName: builder.opt(builder.str('approvedByUserName')),
    cmDeadlineMissed: builder.bool('cmDeadlineMissed'),
    workflowCaseId: builder.opt(builder.str('workflowCaseId')),
    calcWorkflowCaseId: builder.opt(builder.str('calcWorkflowCaseId')),
    calcProgressMonitorId: builder.opt(builder.str('calcProgressMonitorId')),
    validationResult: builder.obj('validationResult', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    }),
    readonly: builder.bool('readonly'),
    manualPrices: builder.bool('manualPrices')
  };
}();